"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
var _a, _API_searchParamsValue;
Object.defineProperty(exports, "__esModule", { value: true });
const types_1 = require("decentraland-crypto-middleware/lib/types");
const logger_1 = __importDefault(require("../../entities/Development/logger"));
const identify_1 = require("../auth/identify");
const storage_1 = require("../auth/storage");
const FetchError_1 = __importDefault(require("../errors/FetchError"));
const RequestError_1 = __importDefault(require("../errors/RequestError"));
const base64_1 = require("../string/base64");
const Options_1 = __importDefault(require("./Options"));
// TODO(#323): remove on v6
require("isomorphic-fetch");
class API {
    constructor(baseUrl = '', defaultOptions = new Options_1.default({})) {
        this.baseUrl = '';
        this.defaultOptions = new Options_1.default({});
        this.baseUrl = baseUrl || '';
        this.defaultOptions = defaultOptions;
    }
    static catch(prom) {
        return prom.catch((err) => {
            logger_1.default.error(err);
            return null;
        });
    }
    static fromPagination(_b, options) {
        var { page } = _b, data = __rest(_b, ["page"]);
        return Object.assign(Object.assign({}, data), { limit: options.pageSize, offset: (page - 1) * options.pageSize });
    }
    static searchParams(data, options = {}) {
        const params = new URLSearchParams();
        const keys = Object.keys(data);
        for (const key of keys) {
            const value = data[key];
            if (value === undefined || value === null) {
                continue;
            }
            if (Array.isArray(value)) {
                for (const each of value) {
                    params.append(key, __classPrivateFieldGet(this, _a, "m", _API_searchParamsValue).call(this, each, options));
                }
            }
            else {
                params.append(key, __classPrivateFieldGet(this, _a, "m", _API_searchParamsValue).call(this, value, options));
            }
        }
        if (options === null || options === void 0 ? void 0 : options.default) {
            for (const param of Object.keys(options.default)) {
                if (data[param] === options.default[param]) {
                    params.delete(param);
                }
            }
        }
        return params;
    }
    static url(base, path = '', query = {}) {
        if (base.endsWith('/')) {
            base = base.slice(0, -1);
        }
        if (path !== '' && !path.startsWith('/')) {
            path = '/' + path;
        }
        let params = new URLSearchParams(query).toString();
        if (params) {
            if (path.includes('?')) {
                params = '&' + params;
            }
            else {
                params = '?' + params;
            }
        }
        return base + path + params;
    }
    url(path, query = {}) {
        return API.url(this.baseUrl, path, query);
    }
    options(options = {}) {
        return new Options_1.default(options);
    }
    /** @deprecated use API.searchParams instead */
    query(qs) {
        if (!qs) {
            return '';
        }
        const params = new URLSearchParams();
        for (const key of Object.keys(qs)) {
            if (qs[key] === null) {
                params.set(key, '');
            }
            else if (qs[key] !== undefined) {
                params.set(key, qs[key]);
            }
        }
        const queryString = params.toString();
        if (!queryString) {
            return '';
        }
        return '?' + queryString;
    }
    authorizeOptions(path, options = new Options_1.default({})) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = options.getAuthorization();
            if (config.identity) {
                const identity = (0, storage_1.getCurrentIdentity)();
                if (!(identity === null || identity === void 0 ? void 0 : identity.authChain) && !config.optional) {
                    throw new FetchError_1.default(path, options.toObject(), 'Missing identity to autorize the request');
                }
                if (identity === null || identity === void 0 ? void 0 : identity.authChain) {
                    options.header('Authorization', 'Bearer ' + (0, base64_1.toBase64)(JSON.stringify(identity.authChain)));
                }
            }
            return options;
        });
    }
    signOptions(path, options = new Options_1.default({})) {
        return __awaiter(this, void 0, void 0, function* () {
            const config = options.getAuthorization();
            if (config.sign) {
                const identity = (0, storage_1.getCurrentIdentity)();
                if (!(identity === null || identity === void 0 ? void 0 : identity.authChain) && !config.optional) {
                    throw new FetchError_1.default(path, options.toObject(), 'Missing identity to sign the request');
                }
                if (identity === null || identity === void 0 ? void 0 : identity.authChain) {
                    const timestamp = String(Date.now());
                    const pathname = new URL(this.url(path), 'https://localhost').pathname;
                    const method = options.getMethod() || 'GET';
                    const metadata = JSON.stringify(options.getMetadata());
                    const payload = [method, pathname, timestamp, metadata]
                        .join(':')
                        .toLowerCase();
                    const chain = yield (0, identify_1.signPayload)(identity, payload);
                    chain.forEach((link, i) => options.header(types_1.AUTH_CHAIN_HEADER_PREFIX + i, JSON.stringify(link)));
                    options.header(types_1.AUTH_TIMESTAMP_HEADER, timestamp);
                    options.header(types_1.AUTH_METADATA_HEADER, metadata);
                    return options;
                }
            }
            return options;
        });
    }
    fetch(path, options = new Options_1.default({})) {
        return __awaiter(this, void 0, void 0, function* () {
            let res;
            let body = '';
            let json = null;
            const url = this.url(path);
            let opt = this.defaultOptions.merge(options);
            opt = yield this.authorizeOptions(path, opt);
            opt = yield this.signOptions(path, opt);
            try {
                res = yield fetch(url, opt.toObject());
            }
            catch (error) {
                throw new FetchError_1.default(url, opt.toObject(), error.message);
            }
            try {
                body = yield res.text();
            }
            catch (error) {
                throw new RequestError_1.default(url, opt.toObject(), res, body);
            }
            try {
                json = JSON.parse(body || '{}');
            }
            catch (error) {
                throw new RequestError_1.default(url, opt.toObject(), res, error.message + ' at ' + body);
            }
            if (res.status >= 400) {
                throw new RequestError_1.default(url, opt.toObject(), res, json);
            }
            return json;
        });
    }
}
exports.default = API;
_a = API, _API_searchParamsValue = function _API_searchParamsValue(value, options) {
    if (value instanceof Date) {
        return options.dataToTimestamp ? String(value.getTime()) : value.toJSON();
    }
    return String(value);
};
